import { render, staticRenderFns } from "./EarlyYearDetail.vue?vue&type=template&id=13c34fa0"
import script from "@/controllers/custom/early-year/early-year-detail.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/early-year/early-year-detail.js?vue&type=script&lang=js&external"
import style0 from "./EarlyYearDetail.vue?vue&type=style&index=0&id=13c34fa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports